<template>
  <div id="privacy" class="body-container">
    <div class="body-content">
      <termsEn></termsEn>
      <privacyEn></privacyEn>
    </div>
  </div>
</template>

<script>
import privacyEn from '../privacy_en/privacy_en.vue'
import termsEn from '../terms_en/terms_en.vue'
export default {
  name: 'privacy',
  data () {
    return {}
  },
  components: {
    privacyEn,
    termsEn
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#privacy
  margin .25rem
  font-size 0.14rem
  line-height 0.24rem
  text-align justify
  height auto
  h1

    margin-top 0.5rem
    font-weight bold
    font-size 0.26rem
  div
    text-indent 0.31rem
    margin .1rem 0
    &.title
      text-indent 0
      font-weight bold
      font-size 0.16rem
    &.sub-p
      text-indent 0.59rem
    a
      color #000
      &:hover
        color #0982cb
</style>



// WEBPACK FOOTER //
// privacy_terms_en.vue?43223020